// extracted by mini-css-extract-plugin
export default {"root":"CompilationsSection__root--16Ni6","title":"CompilationsSection__title--2nXoK","section":"CompilationsSection__section--gBCQx"};